
import Header from "../../header";
import Footer from "../../footer";
import ContactForm from "../../contactcomponents/contactform";
import BannerFooter from "../productpages/bannerForFooter";
import traningimage from '../../../images/footerLinksImages/featuresimage/traning.jpg'
function HandsOnTraning() {
    const keywords = [
        { title: "Practical Skill Building", summary: "Engage in real-world exercises that focus on developing practical skills to enhance your professional capabilities." },
        { title: "Project-Based Learning", summary: "Work on live projects that allow you to apply your knowledge and gain experience in real industry scenarios." },
        { title: "Hands-On Workshops", summary: "Participate in interactive workshops where you can practice techniques and learn through hands-on activities." },
        { title: "Expert-Led Training", summary: "Learn from experts who provide step-by-step guidance, helping you understand complex concepts through practical examples." },
        { title: "Real-World Simulations", summary: "Experience simulations that mimic real-world situations, preparing you for practical challenges in your field." },
        { title: "Skill Development Sessions", summary: "Build your skill set with specialized training sessions focused on practical, in-demand techniques." },
        { title: "Live Demonstrations", summary: "Watch live demonstrations of practical tasks, giving you a visual understanding of how things work in real time." },
        { title: "Industry-Relevant Tools", summary: "Access and use tools that are widely used in the industry, ensuring you are well-prepared for the job market." },
        { title: "Collaborative Learning", summary: "Work with peers in a collaborative setting, exchanging knowledge and learning from each other through practical tasks." },
        { title: "Continuous Practice Opportunities", summary: "Get multiple opportunities to practice and refine your skills with consistent hands-on tasks." },
      ];
    return (<>
        <Header />
      
        <BannerFooter
            title="Hands-On Training & Practical Learning"
            text="We believe in the power of hands-on training to ensure that students gain real-world experience. Our courses are designed to provide practical learning opportunities, where students can apply their knowledge in real scenarios. From interactive labs to live projects, our approach focuses on developing skills that are essential for professional success. By engaging in practical exercises, students gain confidence and are better prepared to tackle challenges in their careers. Whether in technology, business, or creative fields, our hands-on training ensures that learners are industry-ready, equipped with the tools and experience to excel."
            imageone={traningimage}
            imagetwo={traningimage}
        />

<div className="container-fluid py-5 bg-light">
  <div className="container p-4 shadow-lg bg-white rounded">
    <h2 className="text-center mb-4">Hands-On Training & Practical Learning</h2>
    <div className="accordion" id="trainingAccordion">
      {keywords.map((item, index) => (
        <div className="accordion-item" key={index}>
          <h2 className="accordion-header" id={`heading-${index}`}>
            <button
              className="accordion-button collapsed"
              type="button"
              data-bs-toggle="collapse"
              data-bs-target={`#collapse-${index}`}
              aria-expanded="false"
              aria-controls={`collapse-${index}`}
              style={{ transition: "all 0.3s ease" }}
            >
              {item.title}
            </button>
          </h2>
          <div
            id={`collapse-${index}`}
            className="accordion-collapse collapse"
            aria-labelledby={`heading-${index}`}
            data-bs-parent="#trainingAccordion"
          >
            <div className="accordion-body">
              {item.summary}
            </div>
          </div>
        </div>
      ))}
    </div>
  </div>
</div>
        <ContactForm />
        <Footer />
    </>)
}

export default HandsOnTraning